import Card, { PaddingOptions as _PaddingOptions } from './Card';

export type PaddingOptions = _PaddingOptions;
export default Card;
